// Quick-create de empresa — busca dados via API Brasil pelo CNPJ se for o caso.
// Extraído de ComercialPipeline.tsx em 2026-05-23 (frontend wave 3B).
import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Card, Input, Modal, Form, Typography, Row, Col, App as AntApp,
} from 'antd';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import BuscaCnpjBox, { consultarCnpjBrasilApi, formatarCnpj as formatarCnpjUtil } from '../BuscaCnpjBox';

const { Text } = Typography;

export function FormCriarCliente({ termo, onClose, onCriado }: {
  termo: string; onClose: () => void; onCriado: (cliente: any) => void;
}) {
  const { message } = AntApp.useApp();
  const termoLimpo = termo.replace(/\D/g, '');
  const ehCnpj = termoLimpo.length === 14;
  const [form, setForm] = useState<any>({
    razao_social: ehCnpj ? '' : termo,
    nome_fantasia: '',
    cnpj: ehCnpj ? formatarCnpjUtil(termo) : '',
    segmento: '', porte: '',
    cnae_codigo: '', cnae_descricao: '',
    endereco: '', bairro: '', cidade: '', uf: '', cep: '',
    contato_fone: '', contato_email: '',
    situacao_rfb: '', data_abertura: null,
  });
  const [salvando, setSalvando] = useState(false);

  function aplicarDadosRfb(dados: any) {
    setForm((f: any) => ({
      ...f, ...dados,
      razao_social: f.razao_social && f.razao_social !== termo ? f.razao_social : dados.razao_social,
      segmento: f.segmento || dados.cnae_descricao,
      rfb_atualizado_em: new Date().toISOString(),
    }));
  }

  useEffect(() => {
    if (ehCnpj) consultarCnpjBrasilApi(termoLimpo).then(aplicarDadosRfb).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function salvar() {
    if (!form.razao_social.trim()) { message.warning('Razão social obrigatória'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      const res = await axios.post(`${API_URL}/comercial/clientes`, form, { headers: { Authorization: token } });
      const data = res.data.body ? JSON.parse(res.data.body) : res.data;
      message.success('Empresa criada.');
      onCriado(data);
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.error || e.response?.data?.erro || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <Modal open onCancel={onClose} onOk={salvar} confirmLoading={salvando}
      title="Nova empresa (rápida)" okText="Criar e usar" cancelText="Cancelar" width={600} destroyOnClose>
      <BuscaCnpjBox cnpjInicial={form.cnpj} onEncontrado={aplicarDadosRfb} />
      <Form layout="vertical" size="small">
        <Form.Item label="Razão social" required>
          <Input value={form.razao_social} onChange={e => setForm({ ...form, razao_social: e.target.value })} />
        </Form.Item>
        <Row gutter={10}>
          <Col span={12}><Form.Item label="CNPJ"><Input value={form.cnpj} onChange={e => setForm({ ...form, cnpj: e.target.value })} /></Form.Item></Col>
          <Col span={12}><Form.Item label="Porte"><Input value={form.porte} onChange={e => setForm({ ...form, porte: e.target.value })} /></Form.Item></Col>
        </Row>
        {form.nome_fantasia && (
          <Form.Item label="Nome fantasia">
            <Input value={form.nome_fantasia} onChange={e => setForm({ ...form, nome_fantasia: e.target.value })} />
          </Form.Item>
        )}
        <Form.Item label="Segmento">
          <Input value={form.segmento} onChange={e => setForm({ ...form, segmento: e.target.value })} />
        </Form.Item>
        {(form.endereco || form.cidade) && (
          <Card size="small" style={{ background: '#F0F1F5' }} bodyStyle={{ padding: 8 }}>
            <Text style={{ fontSize: 10, color: '#666' }}>
              📍 {form.endereco}{form.bairro && `, ${form.bairro}`}{form.cidade && ` — ${form.cidade}/${form.uf}`}{form.cep && ` · CEP ${form.cep}`}
              {form.contato_fone && <><br />📞 {form.contato_fone}</>}
              {form.contato_email && <><br />✉️ {form.contato_email}</>}
              {form.situacao_rfb && <><br />Situação RFB: <strong>{form.situacao_rfb}</strong></>}
            </Text>
          </Card>
        )}
      </Form>
    </Modal>
  );
}
